'use strict';

angular.module('magtac')
  .controller('StatusHistoryCtrl', [
    '$scope', 'statusHistoryViewModel', '$stateParams',
    function ($scope, viewModel, $stateParams) {
      $scope.model = new viewModel(parseInt($stateParams.key));
    }
  ]);
